import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo =
    videoSource === "youtube" ? youtubeVideo : videoSource === "vimeo" ? vimeoVideo : undefined;
  if (!selectedVideo) return null;
  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <VideoPlayer
          banner={videoBanner}
          source={videoSource}
          vimeoVideo={vimeoVideo}
          youtubeVideo={youtubeVideo}
        />
      </div>
    </StratosSection>
  );
};

VideoBlock.displayName = "Block::VideoBlock";
